import * as React from 'react';
import './selectInput.module.scss';
const classNames = require('classnames');

type Props = {
    id?: string;
    name?: string;
    value?: string;
    className?: string;
    styleName?: string;
    children: any;
    onChange?: (nextValue: string) => any;
    onBlur?: (e: React.FormEvent) => any;
    onFocus?: (e: React.FormEvent) => any;
};
export const SelectInput = (props: Props) => {
    return (
        <div styleName="select-wrap">
            <select
                id={props.id}
                name={props.id}
                value={props.value}
                onChange={(e) => props.onChange(e.target.value)}
                onBlur={props.onBlur}
                onFocus={props.onFocus}
                styleName="select"
                className={props.className}
            >
                {props.children}
            </select>
            <i className="fa fa-caret-down" />
        </div>
    );
};
